// components/genre/GenreAnalyticsSettings.jsx
import React from 'react';

const GenreAnalyticsSettings = () => (
    <div className="space-y-4">
        <h3 className="text-sm font-medium text-gray-700">Genre Settings</h3>
        <p className="text-xs text-gray-500">Configure genre analysis settings...</p>
    </div>
);

export default GenreAnalyticsSettings;